import styled from 'styled-components';
import theme from '../../styles/theme.css';

export const VideoContainer = styled.div`
 max-width: 100vw;
 height: 50vh;
 display: grid;
 grid-gap: 10px;
 grid-template-columns: repeat(3, 1fr);
 
 @media (max-width: 764px){
    width: 90vw;
    height: auto;
    margin: 1.5rem auto 2rem auto;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
 }
 iframe{
    padding: 0 2%;
    width: 96%;
    height: 80%;
 }
 p{
   height: 20%;
    font-size: 0.7rem;
    font-family: ${theme.plexMono};
    font-weight: 800;
    padding: 0 2%;
 }
 .time{
    display: flex;
    justify-content: flex-end;
    img{
       width: 20px;
       margin-right: 6px;
       @media (max-width: 764px){
         margin-right: 2px;
       }
    }
 }
`